// extracted by css-extract-rspack-plugin
export default {"backgroundIcon":"Document_backgroundIcon__6WH-7","bzObjTypeHeading":"Document_bzObjTypeHeading__HQT7b"};